@if (timeslotDetails() && timeslotDetails().length > 0) {
  <div
    [ngClass]="containerCssClass()"
    class="book-time-now-container"
  >
    <h3 class="book-time-now-header">{{ headerText() }}</h3>
    <div class="book-time-now-timeslot-container">
      @for (timeslot of timeslotDetails(); let i = $index; track timeslot.careProviderInfo.itemId) {
        <div class="book-time-now-timeslot">
          <div class="book-time-now-timeslot__name">
            {{ timeslot.careProviderInfo.careProviderUnitName }}
          </div>
          <div class="book-time-now-timeslot__service">
            {{ timeslot.careProviderInfo.careServiceName }}
          </div>
          <div class="book-time-now-timeslot__timeslot">
            <app-ui-button
              [class]="'test-timeslot-' + i"
              [eventParams]="timeslot.eventParams"
              (click)="navigateToBookingUrl(timeslot.details.routerLink, timeslot.details.queryParams)"
              appGtmGa4Event
              color="green"
              rel="nofollow"
              size="md"
            >
              {{ timeslot.details.label }}
            </app-ui-button>
          </div>
          <div class="book-time-now-timeslot__address">
            <app-ui-icon color="black" name="marker" size="sm"></app-ui-icon>
            {{ timeslot.careProviderInfo.address }}
          </div>
        </div>
      }
    </div>

    @if (isGetLocationVisible()) {
      <div class="book-time-now-footer">
        <app-ui-button (onClick)="getUserLocation()" [color]="'flat'" size="md">Kliniker nära mig</app-ui-button>
      </div>
    }

    @if (isSeeMoreVisible()) {
      <div class="book-time-now-footer">
        <app-ui-button (onClick)="onSeeMoreClick()" [color]="'flat'" size="md">Upptäck fler lediga tider</app-ui-button>
      </div>
    }

    @if (useExpand()) {
      <div
        (click)="expand()"
        [ngClass]="{ expanded: expanded() }"
        class="book-time-now-expander"
      >
        <div class="book-time-now-expander__icon"></div>
      </div>
    }
  </div>
}

